import { render, staticRenderFns } from "./produceMould.pug?vue&type=template&id=701a6b68&scoped=true&lang=pug&"
import script from "./produceMould.ts?vue&type=script&lang=ts&"
export * from "./produceMould.ts?vue&type=script&lang=ts&"
import style0 from "./produceMould.styl?vue&type=style&index=0&id=701a6b68&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a6b68",
  null
  
)

export default component.exports